import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchemaEdit } from '../../utils/formConfig';

const updateSpotlight: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchemaEdit}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default updateSpotlight;
